import {useHighlightCategoriesQuery} from '@/framework/gql/highlight-categories.graphql';

export function useHighlightCategories() {
    const {data, loading, error} = useHighlightCategoriesQuery();

    return {
        highlightCategories: data?.highlightCategories?.items ?? [],
        loading,
        error,
    };
}
